/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkCreateEquipmentIdentifierSkippedItemResponse } from './bulk-create-equipment-identifier-skipped-item-response';


export interface BulkCreateEquipmentIdentifiersResponse { 
    createdCount: number;
    updatedCount: number;
    unchangedCount: number;
    skippedCount: number;
    skippedItems: Array<BulkCreateEquipmentIdentifierSkippedItemResponse>;
}

